<template>
  <c-modal class-name="remove-transaction-modal" :active="displayModal" title="Удаление проводки" @close="close">
    <error-feedback
      class="warning"
      text="При удалении проводки изменится баланс на Личном счёте сотрудника, а также информация в связанных проводках"
    ></error-feedback>

    <c-input
      type="textarea"
      v-model="comment"
      class="comment"
      floating-label="Комментарий"
      :clearable="true"
      :required-mark="true"
      :invalid="isSubmitted && commentError"
      :error="isSubmitted && commentError"
      :class="{ 'is-invalid': isSubmitted && commentError }"
      max-length="255"
    />

    <template #actions>
      <c-button size="large" class="reset" label="Отменить" @click="close" />
      <c-button class="save" :disabled="pending" label="Удалить" color="secondary" size="large" @click="submit" />
    </template>
  </c-modal>
</template>

<script>
import CTextarea from "@/components/controls/textarea";
import CButton from "@/components/controls2/Button";
import CModal from "@/components/scrollable-modal";
import ErrorFeedback from "@/components/error-feedback";
import { REQUIRED_ERROR } from "@/constants/errorFieldValues";
import Input from "@/components/controls2/Input";

export default {
  components: {
    CTextarea,
    CButton,
    CModal,
    ErrorFeedback,
    "c-input": Input,
  },
  data() {
    return {
      displayModal: false,

      id: false,
      comment: "",

      isSubmitted: false,
      pending: false,
    };
  },
  computed: {
    commentError() {
      return this.comment.trim() ? false : REQUIRED_ERROR;
    },

    isValid() {
      return !this.commentError;
    },
  },

  methods: {
    reset() {
      this.id = null;
      this.comment = "";
      this.pending = false;
      this.isSubmitted = false;
    },

    open(transaction) {
      this.id = transaction.id.value;
      this.displayModal = true;
    },

    close() {
      this.displayModal = false;
      this.reset();
    },

    getParams() {
      return {
        id: this.id,
        comment: this.comment,
      };
    },

    submit() {
      this.isSubmitted = true;

      if (!this.isValid) {
        return;
      }

      this.pending = true;

      const action = "personalEmployee/removeTransaction";
      const params = this.getParams();

      this.$store
        .dispatch(action, params)
        .then((response) => {
          if (response.success) {
            this.$emit("remove");
            this.close();
          }
        })
        .finally(() => {
          this.pending = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars.scss";
.warning {
  margin-bottom: 25px;
}

.is-invalid {
  padding-bottom: 25px;
}

@include onlyStandartMobile {
  .comment {
    margin-bottom: 20px;
  }
}
</style>
<style>
.remove-transaction-modal {
  max-width: 590px !important;
}
</style>
